export default __webpack_public_path__ + "f374d6876183ca8f55c6ae04097a7bf9.jpg";